import { render, staticRenderFns } from "./inserirPautaFarmaciaPatologia.vue?vue&type=template&id=6aa23ed5&"
import script from "./inserirPautaFarmaciaPatologia.vue?vue&type=script&lang=js&"
export * from "./inserirPautaFarmaciaPatologia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports